import Button from '@components/designSystem/Button'
import { Headline } from '@components/designSystem/Headline'
import useTypedTranslation from '@hooks/useTypedTranslation'
import { routesFactory } from '@utils/routes.ts'

function NoScansAvailable() {
  const { t } = useTypedTranslation()

  return (
    <div className="flex h-screen w-screen flex-col items-center justify-center gap-6">
      <Headline i18nKey="scanSelection.noScansAvailable.title" />
      <span className="text-center text-lg text-gray-500">
        {t('scanSelection.noScansAvailable.subtitle')}
      </span>
      <Button href={routesFactory.storeSelection(true)}>
        {t('scanSelection.noScansAvailable.back')}
      </Button>
    </div>
  )
}

export default NoScansAvailable

